exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-39ddafa4]{display:flex}", ""]);

// exports
